import {
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Section from "../components/Section";
import Simple from "../components/Simple";
import UAParser from "ua-parser-js";
import AddIcon from "@mui/icons-material/Add";
import { Context } from "../context/ContextProvider";
import instance from "../api/api";
import EditIcon from "@mui/icons-material/Edit";

export default function DetailItem({ i18n, t, deviceType }) {
  let navigate = useNavigate();

  const {
    categories,
    items,
    setItems,
    addOrder,
    setOrders,
    orders,
    newList,
    setNewList,
    amountOfItemsInCart,
    handleAddProduct,
    cartItmes,
    setCartItems,
    handleRemoveProduct,
    totalPrice,
  } = React.useContext(Context);
  const textCutFunc = (text) =>
    `${text
      .trim()
      .split(" ")
      .splice(0, text?.length > 25 ? 4 : 5)
      .join(" ")}  ${text?.length > 25 ? "..." : ""}`;
  const { _id } = useParams();
  const [loading, setLoading] = React.useState(true);
  const [detail, setDetail] = React.useState(null);

  const cartFull =
    cartItmes?.length > 0
      ? cartItmes
          .map((item) => item.qty)
          .reduce((previous, item) => previous + item, 0)
      : 0;

  React.useEffect(() => {
    localStorage.getItem("Order") != null &&
      cartItmes.length === 0 &&
      setCartItems(JSON.parse(localStorage.getItem("Order")));
    //   : null;
    fetch(`https://fatora-sa.herokuapp.com/api/v1/products/detail/${_id}`)
      .then((res) => res.json())
      .then((data) => setDetail(data[0]))
      .then(() => setLoading(false))
      .catch((e) => console.log("error: ", e.message));
  }, []);

  React.useEffect(() => {
    console.log("done");

    // setItems(ddd);
    // console.log("data: ",ddd.productItmes);
    const fetchDataItem = async () => {
      try {
        const { data } = await instance.get(
          "/products/company-limit/62160bc81c5ceec125780794"
        );
        console.log("fetch data item list : ", data[2]);
        // console.log("fetch data item list : ", );
        setItems(data);
        // setLoading(false);

        // const {expoTokenAdminUsers} = await dataExpo.data;
        // console.log("expo token admin:  ", expoTokenAdmin);
        // return expoTokenAdminUsers;
      } catch (error) {
        console.log("error data admin: ", error.message);
        // return;
      }
    };
    fetchDataItem();
  }, []);

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "red" : "#ffffff",
    ...theme.typography.body2,
    padding: theme.spacing(2),
    // width: "100%",
    // paddingTop:theme.spacing(3),
    // marginRight:theme.spacing(1),
    // textAlign: "center",
  }));
  return (
    <Container style={{ paddingTop: 50, paddingBottom: 100 }}>
      {loading ? (
        <Box style={{ textAlign: "center" }}>
          <CircularProgress style={{ color: "gray" }} />
        </Box>
      ) : (
        <Grid container p={0}>
          {/* <Button
            variant="contained"
            fullWidth
            onClick={() =>
              navigate(`/add-product`, {
                state: {
                  product: detail,
                  //...values
                },
              })
            }
          >
            Edite
          </Button> */}
          <Grid
            item
            // style={{ textAlign: "center" }}
            xs={12}
            sm={6}
            md={6}
            lg={6}
          >
            <Button
              variant="contained"
              component="label"
              style={{
                position: "absolute",
                backgroundColor: 'darkgrey',
                marginTop: 0,
                zIndex: 2,
              }}
              onClick={() =>
                navigate(`/add-product`, {
                  state: {
                    product: detail,
                    //...values
                  },
                })
              }
              
              startIcon={<EditIcon />}
            >
              تعديل المنتج
            </Button>
            <Box
              m={0}
              mt={0}
              textAlign="center"
              style={{ backgroundColor: "white", paddingRight: 0 }}
            >
              <Section>
                <Simple deviceType={deviceType} img={detail.image.split(",")} />
              </Section>
            </Box>
          </Grid>
          <Grid
            item
            style={{ textAlign: "center" }}
            xs={12}
            sm={6}
            md={6}
            lg={6}
          >
            <Box m={1} textAlign="left" pt={1}>
              <Typography gutterBottom variant="h6" component="div">
                {detail.name}
              </Typography>
              <Typography style={{ color: "green" }} variant="h11">
                {detail.unit.toFixed(2)} ريال
                <strong
                  style={{
                    textDecorationLine: "line-through",
                    color: "red",
                    paddingRight: "5px",
                  }}
                >
                  {detail.basicPrice.toFixed(2)} ريال
                </strong>
              </Typography>
              <Typography gutterBottom variant="h8" component="div" pt={2}>
                <strong>المواصفات</strong>
                <br />
                {detail?.description.replace(/<\/?[^>]+(>|$)/g, "")}
              </Typography>
            </Box>
            <Button
              variant="contained"
              // m={1}
              sx={{
                margin: 1,
                marginTop: 2,
                backgroundColor: "green",
                // color: "gray",
                ":hover": {
                  bgcolor: "green", // theme.palette.primary.main
                  color: "white",
                },
                ":focus": {
                  bgcolor: "green", // theme.palette.primary.main
                  color: "white",
                },
              }}
              fullWidth
              startIcon={<AddIcon />}
              onClick={() => {
                // console.log(
                //   "jj: ",
                //   cartFull,
                //   cartItmes,
                //   //   localStorage.getItem("Order") != null ? JSON.parse(localStorage.getItem("Order")) :localStorage.getItem("Order")
                //   localStorage.getItem("Order")
                // );
                handleAddProduct(detail);
                // handleAddProduct(detail);
                // localStorage.setItem("CountCart", cartFull);
              }}
            >
              إضافة للسلة
            </Button>
          </Grid>
          <Grid style={{ textAlign: "center" }}>
            <Box m={1} textAlign="left" pt={2}>
              <Typography gutterBottom variant="h5" component="div">
                منتجات أخرى
              </Typography>
            </Box>
            <Grid container justifyContent={i18n.dir()}>
              {items.map((item) => (
                <Grid
                  style={{ textAlign: "center", padding: 5 }}
                  key={item._id}
                  xs={6}
                  sm={3}
                  md={3}
                  lg={2}
                  item
                >
                  <Item>
                    <Box
                      onClick={() => {
                        // console.log(
                        //   "cartItmes: ",
                        //   cartItmes.length,
                        //   JSON.parse(localStorage.getItem("Order"))
                        // );
                        // cartItmes?.length !== 0 &&
                        //   localStorage.setItem(
                        //     "Order",
                        //     JSON.stringify(cartItmes)
                        //   );
                        // cartItmes
                        // JSON.parse(localStorage.getItem("Order")).length;
                        //   ? "done"
                        //   : "test";
                        //   ? localStorage.setItem("Order", cartItmes)
                        navigate(`/${item._id}`);
                        setTimeout(() => {
                          window.location.reload(true);
                        }, 200);
                      }}
                      component="img"
                      sx={{
                        height: "150px",
                      }}
                      alt={"apple"}
                      src={
                        item.image.includes(",")
                          ? item.image.split(",")[0]
                          : item.image
                      }
                    />
                    <Box m={0} textAlign="left">
                      <Typography gutterBottom variant="h12" component="div">
                        {textCutFunc(item.name)}
                      </Typography>
                      <Typography style={{ color: "green" }} variant="caption">
                        {item.unit.toFixed(2)} ريال
                        <strong
                          style={{
                            textDecorationLine: "line-through",
                            color: "red",
                            paddingRight: "5px",
                          }}
                        >
                          {item.basicPrice.toFixed(2)} ريال
                        </strong>
                      </Typography>
                    </Box>
                    <Button
                      variant="text"
                      sx={{
                        marginTop: 1,
                        backgroundColor:
                          item.stock === 0 ? "#FCEDEF" : "lightgray",
                        color: item.stock === 0 ? "red" : "gray",
                        ":hover": {
                          bgcolor: item.stock === 0 ? "#FCEDEF" : "green", // theme.palette.primary.main
                          color: item.stock === 0 ? "red" : "white",
                        },
                        ":focus": {
                          bgcolor: item.stock === 0 ? "#FCEDEF" : "green", // theme.palette.primary.main
                          color: item.stock === 0 ? "red" : "white",
                        },
                      }}
                      fullWidth
                      startIcon={item.stock === 0 ? null : <AddIcon />}
                      onClick={() =>
                        handleAddProduct(item) & (cartItmes?.length > 0) &&
                        localStorage.setItem("Order", JSON.stringify(cartItmes))
                      }
                    >
                      {item.stock === 0 ? "نفذت الكمية" : "إضافة للسلة"}
                    </Button>
                  </Item>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      )}
    </Container>
  );
}

DetailItem.getInitialProps = ({ req }) => {
  let userAgent;
  if (req) {
    userAgent = req.headers["user-agent"];
  } else {
    userAgent = navigator.userAgent;
  }
  const parser = new UAParser();
  parser.setUA(userAgent);
  const result = parser.getResult();
  const deviceType = (result.device && result.device.type) || "desktop";
  return { deviceType };
};

// const jj = [
//   {
//     _id: "637624ff9f59798d8971e6ee",
//     name: "ديور جوي انتنس او دي برفيوم- 90 مل",
//     key: 124,
//     marker: "كريستان ديور",
//     unit: 740,
//     before_vat: 495,
//     after_vat: 569.25,
//     qty: 1,
//     category: "الأكثر مبيعا",
//     description:
//       '<p class="ql-direction-rtl">عطر جوي إنتنس من ديور للنساء  او دي بارفيوم</p><p class="ql-direction-rtl">عطر نسائي مميز بالآزهار الفواحة تم اصداره عام 2019&nbsp;</p><p class="ql-direction-rtl">&nbsp;تتكون تركيبته العطرية من البرغموت وزهر البرتقال والورد والياسمين والتونكا وخشب الصندل والفانيلا والمسك</p><p class="ql-direction-rtl">هذا هو العطر الذي يمثل شخصيتك المميزه &nbsp;عطر انيق مناسب لكل الأوقات&nbsp;</p><p><br></p><p><br></p>',
//     basicPrice: 760,
//     category_id: 11,
//     stock: 1000000,
//     image: "https://cdn.salla.sa/yKU0kCl9xgyS0nuaiW4bKX0kIRUxU70AAnnh4JTV.jpeg",
//     company_id: "62160bc81c5ceec125780794",
//     __v: 0,
//     created_at: "2022-11-17T12:11:43.421Z",
//     updatedAt: "2022-11-28T13:28:35.161Z",
//     imageLocaly: "",
//     serialNumber: "",
//   },
// ];
